import ErrorMessages from '@/models/ErrorMessages';

interface MappedError {
  message: string;
  state: string;
}

export default class SurveyErrorHandler {
  public errors: string[];

  constructor(error: { errors: string[] }) {
    this.errors = error.errors;
  }

  private get mappedErrors(): MappedError[] {
    return [
      { message: 'SURVEY_SUSPENDED', state: 'SURVEY_SUSPENDED' },
      { message: 'The evaluation period has expired!', state: 'surveyExpired' },
      { message: 'Transaction already rated', state: 'surveyAlreadyDone' },
      { message: 'Invalid score for this survey type', state: 'surveyInvalidScore' },
      { message: 'Journey is not actived', state: 'surveyInativeJourney' },
      { message: 'Survey blocked', state: 'surveyBlocked' },
    ];
  }

  public handle(): MappedError {
    return this.handleError(this.mappedErrors, 0, this.errors);
  }

  private handleError(mappedErrors: MappedError[], mappedErrorPosition: number, thrownErrors: string[]): MappedError {
    const mappedError = mappedErrors[mappedErrorPosition];

    if (thrownErrors?.some(e => e?.toLowerCase() === mappedError.message?.toLowerCase())) {
      return {
        message: mappedError.message,
        state: mappedError.state,
      };
    }

    const isLastMappedError = mappedErrorPosition === mappedErrors.length - 1;
    if (isLastMappedError) {
      return {
        message: ErrorMessages.surveyNotFound,
        state: 'surveyNotFound',
      };
    }

    return this.handleError(mappedErrors, (mappedErrorPosition = mappedErrorPosition + 1), thrownErrors);
  }
}
